import RequestBodyViewToggle_vue_vue_type_script_setup_true_lang_default from "./RequestBodyViewToggle.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/request-block/components/RequestBodyViewToggle.vue
var RequestBodyViewToggle_default = RequestBodyViewToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestBodyViewToggle_default as default };

//# sourceMappingURL=RequestBodyViewToggle.vue.js.map